export default __webpack_public_path__ + "static/media/92.639a6ee8.png";